import { render, staticRenderFns } from "./ui-rich-select.vue?vue&type=template&id=1b2c47ff&scoped=true&"
import script from "./ui-rich-select.vue?vue&type=script&lang=js&"
export * from "./ui-rich-select.vue?vue&type=script&lang=js&"
import style0 from "./ui-rich-select.vue?vue&type=style&index=0&id=1b2c47ff&lang=scss&scoped=true&"
import style1 from "./ui-rich-select.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2c47ff",
  null
  
)

export default component.exports